<template>
  <div class="binding">
    <weui-group :notitle="true">
      <weui-cell tips="为你提供以下预约信息">
        <router-link role="button" class="btn_guide" :to="{ name: ROUTE_GUIDE }">身体觉醒教练端</router-link>
      </weui-cell>
    </weui-group>
    <weui-group tips="下载身材觉醒教练端，专业教练即可以轻松管理课程安排，提高工作效率，加强会员服务的专业度。" />
    <weui-group tips="您还没有绑定私人教练，所以还不能立刻约课" />
    <weui-group>
      <weui-button-cell :to="{ name: ROUTE_SHARE_BINDING, params: { hash: this.hash } }" replace>立刻绑定{{ coach && coach.name }}教练</weui-button-cell>
      <weui-button-cell :to="{ name: ROUTE_SHARE_TIMES, params: { hash: this.hash } }">继续查看教练可预约时段</weui-button-cell>
    </weui-group>
  </div>
</template>

<script>
import { WeuiGroup, WeuiCell, WeuiButtonCell } from '@/components/weui';
import { ROUTE_GUIDE, ROUTE_SHARE_BINDING, ROUTE_SHARE_TIMES } from '@/router/names';

export default {
    props: {
        hash: {
            type: String,
            required: true,
        },
        coach: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    data() {
        return {
            ROUTE_SHARE_BINDING,
            ROUTE_SHARE_TIMES,
            ROUTE_GUIDE,
        };
    },
    components: {
        WeuiGroup,
        WeuiCell,
        WeuiButtonCell,
    },
};
</script>

<style lang="scss" scoped>
@import './../../assets/scss/variables';

.btn_guide {
    color: $blue;
}
</style>




// WEBPACK FOOTER //
// src/components/share/Unbound.vue